import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import colors from 'aria-viewer/tour/constants/style/colors'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import ComponentUnmounter from 'aria-viewer/utils/componentUnmounter'
import { TOUR_DRAWER, STOP_LIST_DRAWER, MAP_DRAWER } from 'aria-viewer/drawer/drawerMenuActions'

const S = {
    position: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    boxShadowToLeft: {
        display: 'block',
        position: 'absolute',
        background: 'linear-gradient(to left, rgba(8, 19, 30, 0), rgba(8, 19, 30, 0.3))',
        top: 0,
        width: 100,
        bottom: 0,
        left: '100%',
    },
    boxShadowToRight: {
        display: 'block',
        position: 'absolute',
        background: 'linear-gradient(to right, rgba(8, 19, 30, 0), rgba(8, 19, 30, 0.3))',
        top: 0,
        right: '100%',
        bottom: 0,
        width: 100,
    },
}

class Drawer extends PureComponent {
    static defaultProps = { boxShadow: true }

    getX() {
        const { location, drawer, name, open } = this.props

        if (location === 'left' || location === 'right') {
            const isOpen = drawer == name || open
            if (isOpen) {
                return 0
            } else if (location === 'left') {
                return -100
            } else {
                return 100
            }
        }
        return 0
    }

    getY() {
        const { location, drawer, name, open } = this.props

        if (location === 'top' || location === 'bottom') {
            const isOpen = drawer == name || open
            if (isOpen) {
                return 0
            } else if (location === 'top') {
                return -100
            } else {
                return 100
            }
        }
        return 0
    }

    getBoxShadow() {
        return (
            this.props.boxShadow &&
            (this.props.drawer == this.props.name || this.props.open) && (
                <div>
                    <div style={S.boxShadowToLeft} />
                    <div style={S.boxShadowToRight} />
                </div>
            )
        )
    }

    render() {
        const x = this.getX()
        const y = this.getY()

        return (
            <div
                style={Object.assign(
                    {
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: this.props.width || '100%',
                        height: this.props.height || '100%',
                        background: colors.grey_1,
                        transform: `translate3d(${x}%, ${y}%, 0)`,
                        transition: `transform ${styleguide.delay.normal}`,
                        zIndex: 2000,
                    },
                    this.props.style
                )}
            >
                {this.getBoxShadow()}

                <ComponentUnmounter
                    timeOut={this.props.UnmountTimeOut}
                    style={S.position}
                    visible={this.props.drawer == this.props.name || this.props.open || this.props.ignoreUnmount}
                >
                    {this.props.children}
                </ComponentUnmounter>
            </div>
        )
    }
}

export default connect(mapSelectorsToProps(['drawer']))(Drawer)
